<template>
  <div class="wrapper">
    <drag-header />
    <div
      class="btn_close"
      @click="close"
    />
    <div class="header-area">
      <p class="header-title">
        <em />开通PDF会员
      </p>
      <p class="info-content">
        <span
          v-if="!isMember"
          class="account"
        >你正在为
          <em>{{ userInfo ? userInfo.nickname : '' }}</em> 开通会员</span>
        <span
          v-else
          class="account"
        ><em>{{ userInfo ? userInfo.nickname : '' }}</em> 已开通会员</span>
      </p>
      <div class="introduction">
        <dl>
          <dt>
            <img
              :src="propsOption.toolObj.img"
              :alt="propsOption.toolObj.tit"
            >
          </dt>
          <dd class="tit">
            {{ propsOption.toolObj.tit }} <em />
          </dd>
          <dd class="desc">
            <ul>
              <li>{{ propsOption.toolObj.desc[0] }}</li>
              <li>{{ propsOption.toolObj.desc[1] }}</li>
            </ul>
          </dd>
        </dl>
      </div>
    </div>
    <div class="wrap_scroll">
      <Pay
        :charge-type="propsOption.chargeType"
        @paySuccess="paySuccess"
        @qrChange="changePay"
      />

      <interests />
      <ToTop @to_top="toTop" />
    </div>
  </div>
</template>

<script>
import Pay from '@/components/common/CommonPayModule.vue'
import DragHeader from '@/components/common/DragHeader'
import ToTop from '@/components/common/ToTop'
import Interests from '@/components/Interests.vue'
import { mapGetters, mapActions } from 'vuex'
import { PERMISSION_REPORT } from '@/config/dataMap'
import client from '@/client'
export default {
  name: 'ToolPayment',
  components: {
    Pay,
    DragHeader,
    ToTop,
    Interests,
  },
  props: {
    propsOption: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['openId', 'token', 'loginStatus', 'userInfo', 'isMember']),
  },
  mounted () {
    this.reportShow()
  },
  methods: {
    ...mapActions('user', ['refresh']),
    paySuccess (_, refresh) {
      refresh && this.refresh({
        token: this.token,
        open_id: this.openId,
        webRefresh: 1
      })
      setTimeout(() => {
        window.close()
      }, 2000)
    },
    close () {
      window.close()
    },
    reportShow () {
      client.charge.REPORT.reportChargePageShow({
        page_num: PERMISSION_REPORT[this.propsOption.permissionName],
        version: 5
      })
    },
    changePay (param) {
      client.charge.REPORT.reportChargePageSubShow({
        page_num: PERMISSION_REPORT[this.propsOption.permissionName],
        sub_show: param.id,
        version: 5
      })
    },
    toTop () {
      const _parent = document.querySelector('.wrap_scroll')
      _parent.scrollTop = 0
    },
  },

}
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixins.scss';

.btn_close {
  position: absolute;
  right: 0px;
  -webkit-app-region: no-drag;
  display: inline-block;
  vertical-align: middle;
  @include icon_bg;
  width: 26px;
  height: 26px;
  background-position: -5px -262px;
  cursor: pointer;
  margin-right: 5px;
  margin-top: 3px;
  cursor: pointer;
  z-index: 10;

  &:hover {
    background-position: -29px -262px;
  }
}

.wrapper {
  position: relative;
  width: 703px;
  height: 742px;
  margin: 0 auto;
}

.header-area {
  width: 703px;
  height: 120px;
  background: url(~@/assets/images/member-bg.png) no-repeat;
  color: #794a07;
  overflow: hidden;
  background-size: cover;
}

.header-title {
  font-weight: bold;
  font-size: 14px;
  line-height: 25px;
  vertical-align: middle;
  margin-left: 10px;
  color: #a9761f;

  em {
    vertical-align: middle;
    display: inline-block;
    background: url(~@/assets/icons/main/home-logo.png) no-repeat 0 0;
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
}

.introduction {
  dt,
  dd {
    float: left;
  }

  dd {
    margin-left: 19px;
  }

  dd.tit {
    width: 300px;
    margin-top: 5px;
    margin-bottom: 5px;
    font-weight: bold;
    color: #653b00;
    font-size: 18px;
    em {
      display: inline-block;
      width: 34px;
      height: 22px;
      background: url(~@/assets/images/toolpayment/vip.png) no-repeat -2px 0;
    }
  }

  dd.desc {
    font-size: 14px;
    color: #a9761f;
  }

  li {
    padding-left: 20px;
    background: url(~@/assets/images/toolpayment/hook.png) no-repeat 0 3px;
    margin-bottom: 5px;
  }
}

.wrap_scroll {
  position: relative;
  background: #fff;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  height: 622px;
}

.info-content {
  position: absolute;
  top: 0px;
  right: 35px;
  height: 30px;
  line-height: 27px;
}
.account {
  font-size: 12px;
  vertical-align: middle;

  em {
    font-style: normal;
    color: #de461e;
  }
}
.haohuo {
  -webkit-app-region: no-drag;
  color: #fff;
  font-size: 12px;
  display: inline-block;
  width: 16px;
  height: 16px;
  line-height: 35px;
  box-sizing: border-box;
  text-align: left;
  vertical-align: top;
  margin: 8px 10px 0 0;
  cursor: pointer;
  position: relative;
  z-index: 10;
}
</style>
